import { ChangeEvent, ClipboardEvent, FC, KeyboardEvent, MutableRefObject } from 'react';

export type MFADigitInputProps = {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onPaste?: (e: ClipboardEvent<HTMLInputElement>) => void;
  onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  inputRef: MutableRefObject<HTMLInputElement | null>;
};

export const MFADigitInput: FC<MFADigitInputProps> = (props) => {
  return (
    <div className="flex h-14 flex-1 justify-center border border-x border-white-12 bg-black-40">
      <input
        ref={props.inputRef}
        className="h-14 w-9 bg-transparent text-center text-heading-3 text-white-60"
        type="text"
        onChange={props.onChange}
        onPaste={props.onPaste}
        onKeyDown={props.onKeyDown}
      />
    </div>
  );
};
